// ==================== SENSOR MANAGEMENT (CRUD) ====================

export const FETCH_SENSORS = {
    REQUEST: 'FETCH_SENSORS_REQUEST',
    SUCCESS: 'FETCH_SENSORS_SUCCESS',
    FAILURE: 'FETCH_SENSORS_FAILURE'
};

export const fetchSensorsRequest = (filters = {}) => ({
    type: FETCH_SENSORS.REQUEST,
    payload: filters
});

export const fetchSensorsSuccess = (data) => ({
    type: FETCH_SENSORS.SUCCESS,
    payload: data
});

export const fetchSensorsFailure = (error) => ({
    type: FETCH_SENSORS.FAILURE,
    payload: error
});

// CREATE SENSOR
export const CREATE_SENSOR = {
    REQUEST: 'CREATE_SENSOR_REQUEST',
    SUCCESS: 'CREATE_SENSOR_SUCCESS',
    FAILURE: 'CREATE_SENSOR_FAILURE'
};

export const createSensorRequest = (data) => ({
    type: CREATE_SENSOR.REQUEST,
    payload: data
});

export const createSensorSuccess = (data) => ({
    type: CREATE_SENSOR.SUCCESS,
    payload: data
});

export const createSensorFailure = (error) => ({
    type: CREATE_SENSOR.FAILURE,
    payload: error
});

// UPDATE SENSOR
export const UPDATE_SENSOR = {
    REQUEST: 'UPDATE_SENSOR_REQUEST',
    SUCCESS: 'UPDATE_SENSOR_SUCCESS',
    FAILURE: 'UPDATE_SENSOR_FAILURE'
};

export const updateSensorRequest = ({ id, data }) => ({
    type: UPDATE_SENSOR.REQUEST,
    payload: { id, data }
});

export const updateSensorSuccess = (data) => ({
    type: UPDATE_SENSOR.SUCCESS,
    payload: data
});

export const updateSensorFailure = (error) => ({
    type: UPDATE_SENSOR.FAILURE,
    payload: error
});

// DELETE SENSOR
export const DELETE_SENSOR = {
    REQUEST: 'DELETE_SENSOR_REQUEST',
    SUCCESS: 'DELETE_SENSOR_SUCCESS',
    FAILURE: 'DELETE_SENSOR_FAILURE'
};

export const deleteSensorRequest = (id) => ({
    type: DELETE_SENSOR.REQUEST,
    payload: id
});

export const deleteSensorSuccess = (id) => ({
    type: DELETE_SENSOR.SUCCESS,
    payload: id
});

export const deleteSensorFailure = (error) => ({
    type: DELETE_SENSOR.FAILURE,
    payload: error
});

// TOGGLE SENSOR ACTIVE
export const TOGGLE_SENSOR_ACTIVE = {
    REQUEST: 'TOGGLE_SENSOR_ACTIVE_REQUEST',
    SUCCESS: 'TOGGLE_SENSOR_ACTIVE_SUCCESS',
    FAILURE: 'TOGGLE_SENSOR_ACTIVE_FAILURE'
};

export const toggleSensorActiveRequest = (id) => ({
    type: TOGGLE_SENSOR_ACTIVE.REQUEST,
    payload: id
});

export const toggleSensorActiveSuccess = (data) => ({
    type: TOGGLE_SENSOR_ACTIVE.SUCCESS,
    payload: data
});

export const toggleSensorActiveFailure = (error) => ({
    type: TOGGLE_SENSOR_ACTIVE.FAILURE,
    payload: error
});

// FETCH USER ORGANIZATIONS
export const FETCH_USER_ORGANIZATIONS = {
    REQUEST: 'FETCH_USER_ORGANIZATIONS_REQUEST',
    SUCCESS: 'FETCH_USER_ORGANIZATIONS_SUCCESS',
    FAILURE: 'FETCH_USER_ORGANIZATIONS_FAILURE'
};

export const fetchUserOrganizationsRequest = () => ({
    type: FETCH_USER_ORGANIZATIONS.REQUEST
});

export const fetchUserOrganizationsSuccess = (data) => ({
    type: FETCH_USER_ORGANIZATIONS.SUCCESS,
    payload: data
});

export const fetchUserOrganizationsFailure = (error) => ({
    type: FETCH_USER_ORGANIZATIONS.FAILURE,
    payload: error
});

// CLEAR SENSOR MANAGEMENT DATA
export const CLEAR_SENSOR_MANAGEMENT_DATA = 'CLEAR_SENSOR_MANAGEMENT_DATA';

export const clearSensorManagementData = () => ({
    type: CLEAR_SENSOR_MANAGEMENT_DATA
});
